import React, { useCallback, useEffect, useState } from "react";


import { Badge, Button, Dropdown, Form, Input, Menu, Modal, PageHeader, Select, Table, Tag } from "antd";
import { crud } from "@/redux/crud/actions";
import { useDispatch, useSelector } from "react-redux";
import { selectItemById, selectListItems, selectUpdatedItem, selectSearchedItems } from "@/redux/crud/selectors";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EllipsisOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Link, Redirect, useHistory } from "react-router-dom";
import { Switch } from 'antd';
import uniqueId from "@/utils/uinqueId";
import SearchItem from "@/components/SearchItem";
import HeaderContent from "@/layout/HeaderContent";
import Loading from "@/components/Loading";
import { API_BASE_URL, IMAGE_URL, IMAGE_URL_UPLOAD } from "@/config/serverApiConfig";
import axios from "axios";
import TextArea from "antd/lib/input/TextArea";

import { request } from "@/request";
import moment from "moment";

function Directory() {
  const entity = "business-listing";
  const searchConfig = {
    // displayLabels: ["fname", "lname", "email"],
    displayLabels: ["email"],
    searchFields: "companyName",
    outputValue: "_id",
  };
  const { current, isLoading, isSuccess } = useSelector(selectUpdatedItem);

  let [note, setNote] = useState("");
  const [loadForm, setLoadForm] = useState(true)
  const [loadFormView, setLoadFormView] = useState(true)
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);

  let [data, setData] = useState([]);

  let [edit_id, set_edit_id] = useState(0);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [confirmLoadingView, setConfirmLoadingView] = useState(false);
  const [modalText, setModalText] = useState('Content of the modal');
  const [form] = Form.useForm();

  const [isModalVisible, setIsModalVisible] = useState(false);
  let history = useHistory();
  const panelTitle = "Business Directory ";
  const dataTableTitle = "Business Directory Lists";
  const entityDisplayLabels = ["companyName"];

  const { result: listResult, isLoading: listIsLoading } = useSelector(
    selectListItems
  );
  const { pagination, items } = listResult;

  const ADD_NEW_ENTITY = "View Pending Approval User";
  const DATATABLE_TITLE = "Business Directory List";
  const ENTITY_NAME = "Business Directory";
  const CREATE_ENTITY = "Create Business Directory";
  const UPDATE_ENTITY = "Update Business Directory";

  const approve = (data) => {

    data.row.status = true
    data.row.appraval_status = true;
    dispatch(crud.update('business-listing', data.row._id, data.row))
      .then(res => {
      })
      .catch(err => {

      })
      ;
  }
  const disApprove = () => {

    deactiveData.status = false
    deactiveData.note = note
    deactiveData.appraval_status = true


    // data.row.status = false
    // data.row.appraval_status = true;

    dispatch(crud.update('business-listing', deactiveData._id, deactiveData))
      .then(res => {
        setIsModalVisible(false)

      })
      .catch(err => {
        setIsModalVisible(false)


      });
  }
  const readColumns = [
    {
      title: "User Name",
      dataIndex: "user_id",
    },
    {
      title: "Category Name",
      dataIndex: "category_id",
    },
    {
      title: "Subcategory",
      dataIndex: "subcategory_id",
    },
    {
      title: "Company",
      dataIndex: "companyName",
    },
    {
      title: "Name of POC",
      dataIndex: "nameOfPoc",
    },
    {
      title: "Email Of POC",
      dataIndex: "emailOfPoc",
    },
    {
      title: "Mobile Of POC",
      dataIndex: "mobileOfPoc",
    },
    {
      title: "Business Website",
      dataIndex: "businessWebsite",
    },
    {
      title: "Business Phone",
      dataIndex: "businessPhone",
    },
    {
      title: "Country",
      dataIndex: "country",
    },
    {
      title: "City",
      dataIndex: "city",
    },
    {
      title: "Business Intro",
      dataIndex: "businessIntro",
    },
    {
      title: "Date",
      dataIndex: "created",
    },

  ];
  function pendingToggle() {

  }

  const [deactiveData, setDeactiveData] = useState({});
  const showModalNote = ({ row }) => {
    setDeactiveData(row)
    setIsModalVisible(true)
  }
  const handleCancelNote = () => {
    setIsModalVisible(false)
  }
  const dataTableColumns = [
    {
      title: "User Name",
      render: (row) => {
        return (
          <>
            <p>
              {row.user_id && row.user_id.fname ? row.user_id.fname : ""}{" "}
              {row.user_id && row.user_id.lname ? row.user_id.lname : ""}
            </p>
          </>
        );
      },
      // dataIndex: "user_id",
    },
    {
      title: "Category Name",
      sorter: true,
      dataIndex: "category_id",
      render: (row) => {
        return (
          <>
            <p>{row && row.name ? row.name : ""}</p>
          </>
        );
      },
    },
    {
      title: "Subcategory",
      render: (row) => {
        return (
          <>
            <p>
              {row.subcategory_id && row.subcategory_id.name
                ? row.subcategory_id.name
                : ""}
            </p>
            {/* <Switch size="small" defaultChecked disabled={disabled} onChange={() => onChangeSwitch({ row })} /> */}
          </>
        );
      },
    },
    {
      title: "Company",
      sorter: true,
      dataIndex: "companyName",
    },
    {
      title: "Name of POC",
      dataIndex: "nameOfPoc",
    },
    {
      title: "Email Of POC",
      dataIndex: "emailOfPoc",
    },
    {
      title: "Mobile Of POC",
      dataIndex: "mobileOfPoc",
    },
    {
      title: "Business Website",
      dataIndex: "businessWebsite",
    },
    {
      title: "Business Phone",
      dataIndex: "businessPhone",
    },
    {
      title: "Country",
      dataIndex: "country",
    },
    {
      title: "City",
      dataIndex: "city",
    },
    {
      title: "Business Intro",
      // limit the length of the text to show in the table
      render: (row) => {
        return (
          <>
            <p>
              {row.businessIntro
                ? row.businessIntro.substring(0, 50) + "..."
                : ""}
            </p>
          </>
        );
      },
    },
    //     dataIndex: "businessIntro",
    // },
    {
      title: "Date",
      sorter: true,
      // render in date format
      render: (row) => {
        return (
          <>
            <p>
              {row.created ? moment(row.created).format("DD-MMM-YYYY") : ""}
            </p>
          </>
        );
      },
    },
    {
      title: "Time",
      sorter: true,
      // render in date format
      render: (row) => {
        return (
          <>
            <p>{row.created ? moment(row.created).format("hh:mm A") : ""}</p>
          </>
        );
      },
    },
    {
      title: "Updated Date",
      sorter: true,
      // render in date format
      render: (row) => {
        return (
          <>
            <p>
              {
                row.updatestatus ? (
                  <Badge status="success" text="Updated at" />
                ) : (
                  ""
                )} <br />{
                row.updated ? moment(row.updated).format("DD-MMM-YYYY") : ""}
            </p>
          </>
        );

      },
    },
    // if updatestatus is true then show a badge with green color else show nothing


    {
      title: "Approval Status",
      render: (row) => {
        if (row && row.status) {
          setDisabled(true);
          return (
            <>
              <Tag color="green">Approve</Tag>
              {/* <Button type="primary" size="small" disabled>Approved</Button> */}
              {/* <Switch size="small" defaultChecked disabled={disabled} onChange={() => onChangeSwitch({ row })} /> */}
            </>
          );
        } else if (row && "note" in row && row.status == false) {
          return (
            <>
              <Tag color="red">Disapproved</Tag>
              {/* <Button type="primary" size="small" disabled>Disapproved</Button> */}
              {/* <Switch size="small" defaultChecked disabled={disabled} onChange={() => onChangeSwitch({ row })} /> */}
            </>
          );
        } else {
          setDisabled(false);
          return (
            <>
              <Button
                type="primary"
                icon={<CheckOutlined />}
                size="small"
                onClick={() => approve({ row })}
              >
                Approve
              </Button>
              <Button
                type="primary"
                icon={<CloseOutlined />}
                danger
                size="small"
                onClick={() => showModalNote({ row })}
              >
                Disapprove
              </Button>
            </>
          );
        }
      },
    },
    {
      title: "",
      render: (row) => (
        <Dropdown overlay={DropDownRowMenu({ row })} trigger={["click"]}>
          <EllipsisOutlined style={{ cursor: "pointer", fontSize: "24px" }} />
        </Dropdown>
      ),
    },
  ];



  const handelDataTableLoad = useCallback((pagination, filter, sorter) => {


    if (sorter != undefined) {
      dispatch(crud.list(entity, pagination.current, sorter.field, sorter.order));
    }
    else {
      dispatch(crud.list(entity, pagination.current));
    }
  }, []);

  function DropDownRowMenu({ row }) {
    // const dispatch = useDispatch();
    // const { crudContextAction } = useCrudContext();
    // const { panel, collapsedBox, modal, readBox, editBox } = crudContextAction;
    // const item = useSelector(selectItemById(row._id));

    function Delete() {

      dispatch(crud.delete(entity, row._id));
      window.location.reload();


    }

    function Edit() {
      dispatch(crud.currentAction("edit", item));
      editBox.open();
    }





    return (
      <Menu style={{ width: 130 }}>
        <Menu.Item key={`${uniqueId()}`} icon={<EyeOutlined />} onClick={() => showModal(row._id, false)}>

          View
        </Menu.Item>
        <Menu.Item key={`${uniqueId()}`} icon={<EditOutlined />} onClick={() => showModal(row._id, true)} >
          Edit
        </Menu.Item>
        <Menu.Item
          key={`${uniqueId()}`}
          icon={<DeleteOutlined />}
          onClick={Delete}
        >
          Delete
        </Menu.Item>
      </Menu>
    );
  }




  const showModal = (id, isEdit) => {
    set_edit_id(id)
    if (isEdit) {

      setVisible(true);
    }
    else {
      setVisibleView(true);
    }
    axios(`${API_BASE_URL}${entity}/read/${id}`)
      .then(res => {
        setData(res.data.result)
        if (isEdit) {
          setLoadForm(false)
          form.setFieldsValue(
            {
              companyName: res.data.result.companyName,
              category_id: res.data.result.category_id._id,
              subcategory_id: res.data.result.subcategory_id._id,
              companyName: res.data.result.companyName,
              nameOfPoc: res.data.result.nameOfPoc,
              emailOfPoc: res.data.result.emailOfPoc,
              mobileOfPoc: res.data.result.mobileOfPoc,
              businessWebsite: res.data.result.businessWebsite,
              businessPhone: res.data.result.businessPhone,
              country: res.data.result.country,
              city: res.data.result.city,
              businessIntro: res.data.result.businessIntro,
              block_status: res.data.result.block_status,

            }
          );
        }
        else {
          setLoadFormView(false)
        }
      })
      .catch(err => {


      })
  };

  const handleOk = () => {
    setModalText('The modal will be closed after two seconds');
    setConfirmLoading(true);
    setTimeout(() => {
      setVisible(false);
      setConfirmLoading(false);
    }, 2000);
  };

  const handleCancel = (isEdit) => {
    if (isEdit) {

      setVisible(false);
    }
    else {
      setVisibleView(false);
    }
  };

  const onSubmit = () => {
    dispatch(crud.update(entity, edit_id, form.getFieldValue()));
    dispatch(crud.list(entity, pagination.current));
    setVisible(false);
  }


  // const handelDataTableLoad = useCallback((pagination) => {
  //     dispatch(crud.list("user", pagination.current));
  //   }, []);

  useEffect(() => {
    if (isSuccess) {
      dispatch(crud.resetAction("update"));
      // dispatch(crud.list(entity));
    }
  }, [isSuccess]);
  useEffect(() => {
    dispatch(crud.list(entity));
  }, []);
  const config = {
    entity,
    panelTitle,
    dataTableTitle,
    ENTITY_NAME,
    CREATE_ENTITY,
    ADD_NEW_ENTITY,
    UPDATE_ENTITY,
    DATATABLE_TITLE,
    readColumns,
    dataTableColumns,
    searchConfig,
    entityDisplayLabels,
  };
  let [category, setCategory] = useState([]);
  useEffect(() => {
    axios(`${API_BASE_URL}category/getCategory`)
      .then(res => {
        setCategory(res.data.data)
      })
      .catch(err => {


      })
  }, []);
  function onChange({ target: { value } }) {
    setNote(value)
  };

  const [isSearch, setIsSearch] = useState(false);

  let source = request.source();
  const { displayLabels, searchFields, outputValue = "_id" } = searchConfig;
  const search = (event) => {
    if (event.keyCode === 13) {
      if (event.target.value !== "") {
        setIsSearch(true)
        dispatch(
          crud.search(entity, source, {
            question: event.target.value,
            fields: searchFields,
          })
        );
      }
      else {
        setIsSearch(false)
      }
    }
  }
  const { result: result_data_search, isLoadings: isLoadings, isSuccess: Success } = useSelector(selectSearchedItems);

  return (
    <>
      <Modal
        title="Note"
        visible={isModalVisible}
        onOk={disApprove}
        onCancel={handleCancelNote}
      >
        <TextArea
          value={note}
          onChange={onChange}
          autoSize={{ minRows: 3, maxRows: 5 }}
        />
      </Modal>
      <Modal
        title="Edit Directory"
        visible={visible}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => {
          handleCancel(true);
        }}
        footer={[
          <Button
            key="back"
            style={{
              color: 'black',
              borderColor: '#d9d9d9',
            }}
            onClick={() => {
              handleCancel(true);
            }}
          >
            Return
          </Button>,
          <Button key="submit" type="primary" onClick={onSubmit}>
            Submit
          </Button>,
        ]}
      >
        <Loading isLoading={loadForm}>
          <Form name="control-hooks" form={form}>
            <Form.Item label="Category" name="category_id">
              <Select>
                {category.map((value, index) => {
                  return (
                    <Select.Option value={value._id} key={index}>
                      {value.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item label="Subcategory" name="subcategory_id">
              <Select>
                {category.map((value, index) => {
                  return (
                    <Select.Option value={value._id} key={index}>
                      {value.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label="Company"
              name="companyName"
              rules={[
                {
                  required: true,
                  message: "Please input Company Name!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Name Of POC"
              name="nameOfPoc"
              rules={[
                {
                  required: true,
                  message: "Please input Name of POC!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Email of POC"
              name="emailOfPoc"
              rules={[
                {
                  required: true,
                  message: "Please input your email!",
                },
              ]}
            >
              <Input disabled={true} />
            </Form.Item>

            <Form.Item
              label="Mobile of POC"
              name="mobileOfPoc"
              rules={[
                {
                  required: true,
                  message: "Please input mobile!",
                },
              ]}
            >
              <Input disabled={true} />
            </Form.Item>
            <Form.Item
              label="Business Website"
              name="businessWebsite"
              rules={[
                {
                  required: true,
                  message: "Please input business website!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Business Phone"
              name="businessPhone"
              rules={[
                {
                  required: true,
                  message: "Please input business phone!",
                },
              ]}
            >
              <Input disabled={true} />
            </Form.Item>
            <Form.Item
              label="Country"
              name="country"
              rules={[
                // {
                //   type: "email",
                //   message: "The input is not valid E-mail!",
                // },
                {
                  required: true,
                  message: "Please input your country!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="City"
              name="city"
              rules={[
                {
                  required: true,
                  message: "Please Input City",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label="Business Intro"
              name="businessIntro"
              rules={[
                {
                  required: true,
                  message: "Please input business intro!",
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="Block Status" name="block_status">
              <Select>
                <Select.Option value={true}>Block</Select.Option>
                <Select.Option value={false}>Unblock</Select.Option>
              </Select>
            </Form.Item>
          </Form>
        </Loading>
      </Modal>

      <Modal
        style={{ width: "900px!important" }}
        title="View Directory"
        visible={visibleView}
        onOk={handleOk}
        confirmLoading={confirmLoadingView}
        onCancel={() => {
          handleCancel(false);
        }}
        footer={[]}
      >
        <Loading isLoading={loadFormView}>
          <div class="col-12">
            <div class="card" style={{ overflowX: 'auto' }}>
              <div class="card-body">
                <table>
                  <tbody>
                    <tr>
                      <th>User Name:</th>
                      <td>
                        {data.user_id && data.user_id.fname
                          ? data.user_id.fname
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Category Name:</th>
                      <td>
                        {data.category_id && data.category_id.name
                          ? data.category_id.name
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <th>Subcategory:</th>
                      <td>
                        {data.subcategory_id && data.subcategory_id.name
                          ? data.subcategory_id.name
                          : ""}
                      </td>
                      {/* <td>{data.email}</td> */}
                    </tr>

                    <tr>
                      <th>Company Name:</th>
                      <td>{data.companyName}</td>
                    </tr>
                    <tr>
                      <th>Country:</th>
                      <td>{data.country}</td>
                    </tr>
                    <tr>
                      <th>Name Of POC:</th>
                      <td>{data.nameOfPoc}</td>
                    </tr>
                    <tr>
                      <th>Email Of POC:</th>
                      <td>{data.emailOfPoc}</td>
                    </tr>
                    <tr>
                      <th>Mobile Of POC:</th>
                      <td>{data.mobileOfPoc}</td>
                    </tr>
                    <tr>
                      <th>Business Website:</th>
                      <td>{data.businessWebsite}</td>
                    </tr>
                    <tr>
                      <th>Business Phone:</th>
                      <td>{data.businessPhone}</td>
                    </tr>

                    <tr>
                      <th>Country:</th>
                      <td>{data.country}</td>
                    </tr>
                    <tr>
                      <th>City:</th>
                      <td>{data.city}</td>
                    </tr>
                    <tr>
                      <th>Business Intro:</th>
                      <td>{data.businessIntro}</td>
                    </tr>
                    <tr>
                      <th>Business Profile:</th>
                      <td>
                        <a
                          href={`${IMAGE_URL_UPLOAD}/business_profile/${data.businessProfile}`}
                          target="_blank"
                        >
                          {data.businessProfile}{" "}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Loading>
      </Modal>
      <HeaderContent />
      <PageHeader
        onBack={() => window.history.back()}
        title={dataTableTitle}
        ghost={false}
        extra={
          <Input onKeyDown={(e) => search(e)} suffix={<SearchOutlined />} />
        }
        style={{
          padding: "20px 10px",
        }}
      ></PageHeader>

      <div className="table" style={{ padding: "20px" }}>
        {/* <SearchItem config={config} /> */}
        {/* make loader over search and make it true when searching data and false wehen data is loaded */}

        <Loading
          isLoading={
            (isSearch ? listIsLoading : isLoading) ||
            (result_data_search.length ? listIsLoading : isLoading)
          }
        >
          <Table
            columns={dataTableColumns}
            rowKey={(item) => item._id}
            dataSource={isSearch ? result_data_search : items}
            pagination={isSearch ? 1 : pagination}
            // loading={listIsLoading}
            onChange={handelDataTableLoad}
            scroll={{ x: 1500 }}
          />
        </Loading>
      </div>
    </>
  );
}

export default Directory;
